/* istanbul ignore file */

import { createRoot } from 'react-dom/client'

import { i18n } from '@reveni-io/reveni-ui'
import { enTranslations as enReveniUITranslations } from '@reveni-io/reveni-ui'

import { initMixpanel } from './common/helpers/mixpanel'
import enTranslations from './i18n/translations/en'
import App from './App'

import 'react-tippy/dist/tippy.css'
import '@reveni-io/reveni-ui/reveni-ui.css'
import '@reveni-io/reveni-ui/styles.css'
import './index.css'

import './axios.config'

export const i18nInstance = i18n({
  en: { translation: { ...enReveniUITranslations, ...enTranslations } },
})

initMixpanel()

const root = createRoot(document.getElementById('root'))
root.render(<App />)
